import { render, staticRenderFns } from "./SpecialistSelectionModal.vue?vue&type=template&id=3b9fbe27&scoped=true"
import script from "./SpecialistSelectionModal.vue?vue&type=script&lang=js"
export * from "./SpecialistSelectionModal.vue?vue&type=script&lang=js"
import style0 from "./SpecialistSelectionModal.vue?vue&type=style&index=0&id=3b9fbe27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9fbe27",
  null
  
)

export default component.exports